import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Sidebar from "../components/sidebar";
import TopBar from "../components/topbar";

const LayoutContainer = styled.div`
  display: flex;
  height: 100vh;
  background-color: #F9FAFB;
  font-family: 'Prompt', sans-serif;
`;

const MainContent = styled.main`
  flex: 1;
  margin-left: 250px;
  margin-top: 64px;
  padding: 2rem;
  overflow-y: auto;
  min-height: calc(100vh - 64px);
`;

const ContentArea = styled.div`
  max-width: 1600px;
  margin: 0 auto;
`;

const Layout = ({ children }) => {
  const location = useLocation();
  const { user } = useAuth();
  const [activeMenu, setActiveMenu] = useState('');

  // Map routes to menu IDs
  const routeToMenuMap = {
    '/healthbook': 'health-record',
    '/template': 'setup-template',
  };

  // Update active menu based on current route
  useEffect(() => {
    const currentMenuId = routeToMenuMap[location.pathname];
    if (currentMenuId) {
      setActiveMenu(currentMenuId);
    }
  }, [location.pathname]);

  const handleMenuChange = (menuId) => {
    setActiveMenu(menuId);
  };

  return (
    <LayoutContainer>
      <Sidebar
        activeMenu={activeMenu}
        onMenuChange={handleMenuChange}
      />

      <div style={{ flex: 1 }}>
        <TopBar user={user} />

        <MainContent>
          <ContentArea>
            {children}
          </ContentArea>
        </MainContent>
      </div>
    </LayoutContainer>
  );
};

export default Layout;